import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Typography } from '@yanolja-org/ya-com-core'

export const expired = theme => css`
  .cancel-completed &,
  .completed &,
  .cancel-requested & {
    color: ${theme.color.gray400}; // css 사용시 theme 을 통해 컬러를 받는 방법을 모르겠음
  }
`

export const Info = styled.div`
  ${Typography('body2').regular}
  color: ${({ theme }) => theme.color.gray600};
  margin-bottom: 0.4rem;
  text-align: left;
  word-break: break-word;
  ${({ theme }) => expired(theme)};
  &:last-child {
    margin-bottom: 0;
  }

  .black {
    color: ${({ theme }) => theme.color.gray900};
    ${({ theme }) => expired(theme)};
  }
`

export const SubTitle = styled.span`
  color: ${({ theme }) => theme.color.gray900};
  ${Typography('body1').bold}
  margin-bottom: 0.4rem;
  word-break: break-word;
  ${({ theme }) => expired(theme)};
`
